module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_4.4cbc2a95.png";